export default function VehiculosIcon({ size, color }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_726_533)">
        <path
          opacity="0.4"
          d="M1 7.7292C1 7.99031 1.15 8.22642 1.38611 8.33475L7.45833 11.1403C7.66667 11.2348 7.88889 11.2848 8.11111 11.2848C8.33333 11.2848 8.55556 11.2375 8.76389 11.1403L14.8361 8.33475C15.0722 8.22642 15.2222 7.99031 15.2222 7.7292C15.2222 7.46809 15.0722 7.23197 14.8361 7.12364L13.3583 6.44031L9.13611 8.39031C8.48611 8.69031 7.73611 8.69031 7.08611 8.39031L2.86389 6.44031L1.38611 7.12364C1.15 7.23197 1 7.46809 1 7.7292Z"
          fill={color}
        />
        <path
          d="M7.45833 0.762524C7.87222 0.570858 8.35 0.570858 8.76389 0.762524L14.8361 3.56808C15.0722 3.67641 15.2222 3.91252 15.2222 4.17364C15.2222 4.43475 15.0722 4.67086 14.8361 4.77919L8.76389 7.58475C8.35 7.77641 7.87222 7.77641 7.45833 7.58475L1.38611 4.77919C1.15 4.66808 1 4.43197 1 4.17364C1 3.9153 1.15 3.67641 1.38611 3.56808L7.45833 0.762524ZM13.3583 9.99586L14.8361 10.6792C15.0722 10.7875 15.2222 11.0236 15.2222 11.2847C15.2222 11.5459 15.0722 11.782 14.8361 11.8903L8.76389 14.6959C8.35 14.8875 7.87222 14.8875 7.45833 14.6959L1.38611 11.8903C1.15 11.7792 1 11.5431 1 11.2847C1 11.0264 1.15 10.7875 1.38611 10.6792L2.86389 9.99586L7.08611 11.9459C7.73611 12.2459 8.48611 12.2459 9.13611 11.9459L13.3583 9.99586Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_726_533">
          <rect
            width="16"
            height="15"
            fill="white"
            transform="translate(0 0.618774)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
